import { SupportedNetwork, Network } from '@spritz-finance/sdk'

export const networkColors: Record<SupportedNetwork, { bgLight: string; bgDark: string }> = {
    [Network.Polygon]: {
        bgLight: 'rgba(239, 243, 255, 1)',
        bgDark: 'rgba(121, 144, 213, 1)',
    },
    [Network.Ethereum]: {
        bgLight: 'rgba(231, 250, 244, 1)',
        bgDark: 'rgba(87, 161, 138, 1)',
    },
    [Network.Binance]: {
        bgLight: 'rgba(255, 242, 226, 1)',
        bgDark: 'rgba(205, 139, 57, 1)',
    },
    [Network.Optimism]: {
        bgLight: '#ffc7ce75',
        bgDark: '#FF6476',
    },
    [Network.Arbitrum]: {
        bgLight: '#E1F3FE',
        bgDark: '#3297D8',
    },
    [Network.Avalanche]: {
        bgLight: '#ffdbdbab',
        bgDark: '#D95D5D',
    },
}
